<template>
  <vx-card no-shadow class="user-settings-general-component">
    <!-- Img Row -->
    <div class="flex flex-wrap items-center mb-base">
      <vs-avatar
        :src="activeUserInfo.image"
        size="70px"
        class="mr-4 mb-4"
      />
      <div>
        <vs-button
          class="mr-4 sm:mb-0 mb-2"
          @click.prevent="popupActive = true"
        >
          Atualizar Foto
        </vs-button>
        <p class="text-sm mt-2">
          Permitido JPG, GIF ou PNG. Tamanho máximo de 10mb
        </p>
      </div>
    </div>

    <vs-popup
      class="user-settings-upload-image-popup"
      title="Atualizar Imagem"
      :active.sync="popupActive"
      style="z-index: 99999;"
      id="sizePopup"
    >
      <upload
        :action="uploadApiUrl"
        fileName="file"
        :headers="{
          Authorization: 'Bearer ' + bearer
        }"
        ref="uploadComponent"
        text="Escolher Imagem"
        automatic
        :limit="1"
        :maxSize="10"
        :single-upload="true"
        @on-success="successUpload"
        @on-error="errorUpload"
        @on-upload-start="imageUploaded = false"
      />

      <div class="flex flex-wrap items-center justify-center">
        <vs-button
          class="mr-4 sm:mb-0 mb-2"
          type="filled"
          color="rgb(62, 201, 214)"
          :disabled="!imageUploaded"
          @click.prevent="updateProfilePicture"
        >
          Salvar
        </vs-button>
      </div>
    </vs-popup>
  </vx-card>
</template>

<script>
  import Upload from '@/components/upload/Upload'

  export default {
    components: {
      Upload
    },
    data() {
      return {
        popupActive: false,
        newImageUrl: null,
        imageUploaded: false
      }
    },
    computed: {
      uploadApiUrl() {
        return localStorage.getItem('baseUrl') + '/api/file/upload'
      },
      bearer() {
        return this.$store.state.auth.bearer
      },
      activeUserInfo() {
        return this.$_.cloneDeep(this.$store.state.AppActiveUser)
      }
    },
    methods: {
      updateProfilePicture() {
        this.activeUserInfo.image = this.newImageUrl
        this.updateUser()
        this.popupActive = false
      },
      errorUpload(request) {
        this.$vs.notify({
          color: 'danger',
          title: 'Erro ao carregar a imagem',
          text: request.data.message
        })
        this.imageUploaded = false
      },
      successUpload(response) {
        this.$vs.notify({
          color: 'success',
          title: 'Imagem carregada com sucesso',
          text: response.data.message
        })

        this.newImageUrl = response.data.fileUrl
        this.imageUploaded = true
      },
      updateUser() {
        //this.activeUserInfo.chosenInstances = this.activeUserInfo.userInstances.map((instance) => instance.id)
        this.$store.dispatch("user/update", this.activeUserInfo).then(response => {
          this.$store.dispatch('updateUserInfo', response.data.data.updateUser.user)
          this.$refs.uploadComponent.removeFile(this.$refs.uploadComponent.index, true)
        }).catch(err => {
          console.error(err)
        })
      }
    }
  }
</script>

<style lang="scss">
  .user-settings-upload-image-popup {
    .con-img-upload {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
</style>
